import { createSelector } from "reselect";
import { isEmpty, forIn, isNull } from "lodash";

//EXTRACT THE PART OF THE STATE
const getData = state => {
  const userProfile = state.profile.info;
  const userPrivacy = state.profile.privacy;
  //get all static data
  const { data } = state;
  if (isEmpty(data.income)) {
    return null;
  }
  //if preference is empty return the default value
  if (isEmpty(userProfile)) {
    return null;
  }

  if (isEmpty(userPrivacy)) {
    return null;
  }
  //format the preference and return it

  if (isNull(userProfile.familyIncome)) {
    return null;
  } else {
    if (userPrivacy.income) {
      if (data.income[userProfile.familyIncome]) {
        return {
          label: data.income[userProfile.familyIncome].label,
          value: data.income[userProfile.familyIncome].value,
          description: data.income[userProfile.familyIncome].description
        };
      } else {
        return null;
      }
    } else {
      return null;
    }
  }
};
//VERIFY IF THE JWT IS SET
const getMemberFamilyIncome = createSelector(getData, birthPlace => birthPlace);
export default getMemberFamilyIncome;



// WEBPACK FOOTER //
// ./src/_selectors/profileSelectors/getMemberFamilyIncome.js